/**
 * Example Scenarios for SMSF Calculator
 * DISABLED - No example scenarios to prevent Cursor crashes
 */

export const smsfExampleScenarios = [];

/**
 * Load a scenario into the SMSF calculator state
 */
export const loadSmsfScenario = (scenarioId, stateSetters) => {
  console.log('SMSF example scenarios disabled');
  return false;
};

/**
 * Get scenario by ID
 */
export const getSmsfScenario = (scenarioId) => {
  return null;
};

/**
 * Get all scenarios
 */
export const getAllSmsfScenarios = () => {
  return [];
};

/**
 * Get scenarios by category
 */
export const getSmsfScenariosByCategory = (category) => {
  return [];
};
